import { setWrapperWidth } from './owl-carousel';
import { setTopSpace } from './top-space';

var $ = jQuery;

$(document).ready(function(){

    if ( $(".owl-carousel.kb-main-courses").length > 0 ) {
        initializeOwlCarousel();
    }

    if ( $( window ).width() > 767 ) {
        setTopSpace( [document.getElementById('newsletter')] );
    }
    
});

export function initializeOwlCarousel() {

    if ( $( window ).width() < 768 ) {
        $(".owl-carousel.kb-main-courses").owlCarousel({
            dots: true,
            loop: true,
            nav: false,
            items: 1,
            margin: 14,
            autoWidth: true,
            onInitialized: callback,
            onResized: callback,
            onTranslated: callback,
        });

        setWrapperWidth( '.kb-main-wrapper' );
    }
}

const showCurrentPostNum = () => {

    const wrapper = document.querySelector( '.kb-main .post-num' );

    if ( ! wrapper ) {
        return;
    }

    const num = wrapper.querySelector( '.post-num__current' );
    const items = document.querySelectorAll( '.owl-stage .owl-item:not(.cloned)' );
    let postNum = 1;

    for ( const [index, item] of items.entries() ) {

        if ( item.className === 'owl-item active' ) {
            postNum = index + 1;
            break;
        }
    }

    num.textContent = postNum;
}

const callback = () => {
    showCurrentPostNum();
}